<template>
  <vx-card no-shadow>
    <!-- <vs-input
      class="w-full mb-base"
      type="password"
      v-validate="'required|min:6'"
      data-vv-validate-on="blur"
      name="old password"
      label-placeholder="Old Password"
      v-model="old_password"
    />
    <span class="text-danger text-sm mb-base">{{
                errors.first("old password")
              }}</span> -->
    <vs-input
      class="w-full mb-base"
      type="password"
      v-validate="'required|min:6'"
      data-vv-validate-on="blur"
      name="new password"
      label-placeholder="New Password"
      v-model="new_password"
    />
    <span class="text-danger text-sm mb-base">{{
                errors.first("new password")
              }}</span>
    <!-- <vs-input
      class="w-full mb-base"
      type="password"
      v-validate="'required|min:6'"
      data-vv-validate-on="blur"
      name="konfirmasi password"
      label-placeholder="Konfirmasi Password"
      v-model="konfirm_password"
    />
    <span class="text-danger text-sm mb-base">{{
                errors.first("konfirmasi password")
              }}</span> -->
    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" :disabled="!validateForm" @click="updatePassword"
        >Save Changes</vs-button
      >
      <!-- <vs-button
        class="ml-4 mt-2"
        type="border"
        color="warning"
        @click="resetPassword"
        >Reset</vs-button
      > -->
    </div>
  </vx-card>
</template>

<script>
export default {
  props : {
    passData : {type: Object, default : null}
  },
  data() {
    return {
      old_password: "",
      new_password: "",
      konfirm_password: ""
    };
  },
  computed: {
    // activeUserInfo() {
    //   return this.$store.state.AppActiveUser;
    // },
    validateForm() {
      return !this.errors.any() && this.new_password !== "";
    },
  },
  methods: {
    resetPassword() {
      //this.old_password = "";
      this.new_password = "";
      // this.konfirm_password = "";
    },
    // updateWithKonfirm(){
    //   if(this.konfirm_password === this.new_password){
        
    //     this.login()
    //   } else {
    //     this.$vs.notify({
    //           title: "Konfirmasi password gagal",
    //           text: "Konfirmasi password tidak sesuai dengan password baru",
    //           color: "danger",
    //           position: "top-right",
    //         });
    //   }
    // },
    updatePassword() {
      this.$store
        .dispatch("users/cudUsers", [{
          id: this.passData.id,
          password: this.new_password
        }])
        .then((val) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: val.message,
            text: "Pembaruan password berhasil",
            color: "success",
            position: "top-right",
          });
          // this.$emit("callback");
          // this.onActivate();
        })
        .catch((er) => {
          this.$vs.loading.close();
          console.log(er);
          if (er.response) {
            this.$vs.notify({
              title: er.response.data.message,
              text: "Pembaruan password gagal",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              title: 'Oops!',
              text: 'Ada kesalahan, silahkan periksa jaringan anda dan coba refresh lagi',
              color : 'danger',
              position : 'top-right'
            })
          }
        }).finally(()=>{
          this.resetPassword()
        });
    },
    // login() {
    //   this.$vs.loading();
    //   this.$store
    //     .dispatch("auth/login", {
    //       noTelpon: JSON.parse(localStorage.getItem("userInfo")).noTelpon,
    //       password: this.old_password,
    //     })
    //     .then((val) => {
    //       localStorage.setItem("token", val.token);
    //       this.updateProfile();
    //     })
    //     .catch((error) => {
    //       this.$vs.loading.close();
    //       if (error.response) {
    //         console.error(error.response);
    //         this.$vs.notify({
    //           title: "Oops!",
    //           text: "Old Password yang anda masukan tidak diketahui",
    //           color: "danger",
    //           position: "top-right",
    //         });
    //       } else {
    //         this.$vs.notify({
    //           title: "Oops!",
    //           text: "Sedang Terjadi Maintenance",
    //           color: "danger",
    //           position: "top-right",
    //         });
    //       }
    //     });
    // },
  },
};
</script>
